import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';

import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Templates from './pages/Templates';
import ThemeDetail from './pages/ThemeDetail';
import BloggerRedirect from "./components/BloggerRedirect";
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Blog from './pages/Blog';
import PostDetail from './pages/PostDetail';
import Services from './pages/Services';
import HireUs from './pages/HireUs';
import YouTube from './pages/YouTube';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './App.css';
import Disclaimer from './pages/Disclaimer';
import RefundPolicy from './pages/RefundPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import ComingSoon from './pages/ComingSoon';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import ThemePreview from './pages/ThemePreview';
import EnglishWithUma from './pages/EnglishWithUma';
import EnglishUmaWatch from './pages/EnglishUmaWatch';
function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        <Header />
        <ScrollToTop />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/theme/:slug" element={<ThemeDetail />} />

            {/* Blogger static pages */}
            <Route path="/p/:slug" element={<BloggerRedirect />} />

            {/* Blogger posts */}
            <Route path="/:year/:month/:slug.html" element={<BloggerRedirect />} />

            {/* Blogger year / month archives */}
            <Route path="/:year/:month" element={<BloggerRedirect />} />
            <Route path="/:year" element={<BloggerRedirect />} />

            {/* 404 */}
            <Route path="/404" element={<NotFound />} />

            <Route path="/theme-preview/:slug" element={<ThemePreview />} />
            {/* <Route path="/courses" element={<Courses />} /> */}
            <Route path="/courses" element={<ComingSoon />} />
            <Route path="/course/:slug" element={<CourseDetail />} />
            {/* <Route path="/blog" element={<Blog />} /> */}
            <Route path="/blog" element={<ComingSoon />} />

            <Route path="/blog/:slug" element={<PostDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/hire" element={<HireUs />} />
            <Route path="/youtube" element={<YouTube />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />

            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route
              path="/english-with-uma"
              element={<EnglishWithUma />}
            />

            <Route
              path="/english-with-uma/watch/:videoId"
              element={<EnglishUmaWatch />}
            />
            <Route path="*" element={<NotFound />} />

          </Routes>
        </main>
        <Footer />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;